import React from "react";
import { useEffect, useState, useReducer } from "react";
import { useRecoilState } from "recoil";
import { getAccessToken, replaceAll } from "../utils/common";
import { toastState, loadingState } from "../utils/atom";
import axios from "axios";
import KyhImageDropUploader from "../components/KyhImageDropUploader";
import KyhSingleFileUploader from "../components/KyhSingleFileUploader";
import RecipeStep_V4 from "./RecipeStep_V4";
import RecipeIngredients_V4 from "./RecipeIngredients_V4";
import TextViewPopup_V4 from "./TextViewPopup_V4";
import JsonWritePopup_V4 from "./JsonWritePopup_V4";
import StepImageMultiFileUploader_V4 from "./StepImageMultiFileUploader_V4";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const RecipeDetail_V4 = ({ modalClose, idx }) => {
    const [toast, setToast] = useRecoilState(toastState);
    const [loading, setLoading] = useRecoilState(loadingState);
    const [categorys, setCategorys] = useState([]);
    const [popup, setPopup] = useState(false); // 레시피를 TXT로 보는 팝업!
    const [popup2, setPopup2] = useState(false); // json 넣어서 스텝 만드는 팝업!
    const [isModifiedUpdate, setModifiedUpdate] = useState(false);

    const defaultStepRow = {
        title: "",
        instruction: "",
        tips: "",
        filename0: "",
        filename1: "",
        filename2: "",
        filename3: "",
        filename4: "",
        filename5: "",
        filename6: "",
        filename7: "",
        filename8: "",
        filename9: "",
    };
    const defaultIngredientRow = { item: "", capacity: "" };

    const [row, setRow] = useState({
        title: "",
        soge: "",
        servings: "",
        difficulty: "",
        cooking_time: "",
        category: "",
        tags: "",
        is_illustration: 0,
        writer: "",
        source: "",
        ingredients: {
            main: [defaultIngredientRow],
            seasoning: [defaultIngredientRow],
            etc: [defaultIngredientRow],
        },
        steps: [defaultStepRow],
    });

    useEffect(() => {
        (async () => {
            if (idx !== "add") {
                await fetch();
            }
            await getCategorys();
        })();
    }, [idx]);

    async function fetch() {
        const url = `${process.env.REACT_APP_HOST}/v4adm/recipe/${idx}`;
        const { data } = await axios({
            url,
            method: "GET",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${getAccessToken()}`,
            },
        });
        if (data) {
            const obj = {
                title: data.title,
                filename0: data.filename0,
                category: data.category,
                tags: data.tags,
                writer: data.writer || "최고의요리비결",
                source: data.source,
                is_illustration: data.is_illustration,
            };

            try {
                const json = JSON.parse(data.json_data);
                for (const o of json.steps) {
                    delete o.step_number;
                }
                // console.log(json);

                const obj2 = {
                    ...obj,
                    soge: json.soge,
                    servings: json.servings,
                    difficulty: json.difficulty,
                    cooking_time: json.cooking_time,
                    ingredients: json.ingredients,
                    steps: json.steps,
                };
                setRow(obj2);
                console.log(obj2);
            } catch (e) {
                console.log(e);
            }
        }
    }

    async function getCategorys() {
        const url = `${process.env.REACT_APP_HOST}/v4adm/categorys`;
        const { data } = await axios({
            url,
            method: "GET",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${getAccessToken()}`,
            },
        });
        if (data) {
            setCategorys(data);
        }
    }

    const getImageWidth = (imageUrl) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = imageUrl;

            img.onload = () => {
                resolve(img.width); // 이미지의 가로 크기를 반환
            };

            img.onerror = (error) => {
                reject(error); // 이미지 로드에 실패하면 에러 반환
            };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // 중복체크
        // if (row.source) {
        //     const { data } = await axios({
        //         url: `${process.env.REACT_APP_HOST}/v4adm/duplicate_check`,
        //         method: "POST",
        //         data: {
        //             idx,
        //             source: row.source,
        //         },
        //         headers: {
        //             "Content-Type": "application/x-www-form-urlencoded",
        //             Authorization: `Bearer ${getAccessToken()}`,
        //         },
        //     });
        //     if (data.cnt === 1) {
        //         alert("중복되는 데이터가 있습니다.");
        //         setLoading(false);
        //         return;
        //     }
        // }

        // created, modified 제거!
        delete row.created;
        delete row.modified;

        const frm = {};

        if (idx) {
            if (idx !== "add") {
                frm.idx = idx;
            }
        }

        // filename0 가로 크키 구하기!
        if (row.filename0) {
            frm.width = await getImageWidth(row.filename0);
        } else {
            frm.width = 0;
        }
        frm.table = "V4_RECIPE_tbl";
        frm.title = row.title;
        frm.filename0 = row.filename0;
        frm.category = row.category;
        frm.tags = row.tags;
        frm.writer = row.writer;
        frm.source = row.source;
        frm.is_modified_update = isModifiedUpdate ? 1 : 0;
        frm.is_illustration = row.is_illustration ? 1 : 0;

        console.log("@@frm", frm);
        const json_str = JSON.stringify(row);

        // 임시로 json_data 저장
        await axios({
            url: `${process.env.REACT_APP_HOST}/v3crud/write`,
            method: "POST",
            data: {
                table: "V4_RCP_TEMP_tbl",
                idx: "1",
                json_data: json_str,
            },
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${getAccessToken()}`,
            },
        });
        //

        frm.json_data = json_str;

        console.log("frm", frm);

        const { data } = await axios({
            url: `${process.env.REACT_APP_HOST}/v3crud/write`,
            method: "POST",
            data: frm,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${getAccessToken()}`,
            },
        });
        console.log(data);

        setLoading(false);

        setToast({
            isToast: true,
            message: "저장 되었습니다.",
        });

        modalClose(true);
    };

    function addRow(i, direction) {
        const steps = [...row.steps];
        if (direction === "up") {
            steps.splice(i, 0, defaultStepRow);
        } else {
            steps.splice(i + 1, 0, defaultStepRow);
        }
        setTimeout(() => {
            setRow({ ...row, steps });
        }, 300);
    }

    function removeRow(i) {
        const steps = [...row.steps];
        if (i === 0 && steps.length === 1) {
            window.alert("첫번째 행은 삭제할 수 없습니다.");
            return;
        }

        steps.splice(i, 1);
        setRow({ ...row, steps });
    }


    async function handleAllDownload() {
        // 1. File System Access API 사용 (폴더 생성 및 직접 저장)
        if (window.showDirectoryPicker) {
            try {
                // 사용자에게 상위 폴더 선택 요청
                const dirHandle = await window.showDirectoryPicker({
                    mode: "readwrite",
                    startIn: "downloads",
                });

                // 폴더 선택 후 로딩 표시
                setLoading(true);

                // 레시피 제목으로 하위 폴더 생성
                const safeTitle = (row.title || "recipe").replace(/[/\\?%*:|"<>]/g, "_");
                const recipeDirHandle = await dirHandle.getDirectoryHandle(safeTitle, { create: true });

                const steps = [...row.steps];
                let count = 0;

                for (let i = 0; i < steps.length; i++) {
                    const step = steps[i];
                    if (step.filename0) {
                        try {
                            const response = await axios.get(step.filename0, {
                                responseType: "blob",
                            });

                            let ext = "jpg";
                            const match = step.filename0.match(/\.(png|jpg|jpeg|gif|webp)$/i);
                            if (match) ext = match[1];

                            const fileName = `step_${i + 1}.${ext}`;

                            // 생성된 폴더에 파일 저장
                            const fileHandle = await recipeDirHandle.getFileHandle(fileName, { create: true });
                            const writable = await fileHandle.createWritable();
                            await writable.write(response.data);
                            await writable.close();

                            count++;
                        } catch (error) {
                            console.error(`Failed to download ${step.filename0}`, error);
                        }
                    }
                }

                // recipe.txt 저장
                const recipeData = {
                    title: row.title,
                    steps: steps.map((step, index) => {
                        let ext = "jpg";
                        if (step.filename0) {
                            const match = step.filename0.match(/\.(png|jpg|jpeg|gif|webp)$/i);
                            if (match) ext = match[1];
                        }
                        return {
                            filename: `step_${index + 1}.${ext}`,
                            title: step.title,
                            instruction: step.instruction,
                        };
                    }),
                };

                const textHandle = await recipeDirHandle.getFileHandle("recipe.txt", { create: true });
                const writable = await textHandle.createWritable();
                await writable.write(JSON.stringify(recipeData, null, 2));
                await writable.close();

                setLoading(false);
                setToast({
                    isToast: true,
                    message: `${safeTitle} 폴더에 다운로드가 완료되었습니다.`,
                });
                return;

            } catch (err) {
                if (err.name === 'AbortError') {
                    setLoading(false);
                    return;
                }
                console.warn("Folder download failed, falling back to ZIP.", err);
            }
        }

        // 2. ZIP 다운로드 (Fallback)
        setLoading(true);
        try {
            const steps = [...row.steps];
            // console.log(steps);

            const zip = new JSZip();
            let count = 0;

            for (let i = 0; i < steps.length; i++) {
                const step = steps[i];
                if (step.filename0) {
                    try {
                        const response = await axios.get(step.filename0, {
                            responseType: "blob",
                        });

                        // 파일 확장자 추출 (기본값 jpg)
                        let ext = "jpg";
                        const match = step.filename0.match(/\.(png|jpg|jpeg|gif|webp)$/i);
                        if (match) ext = match[1];

                        const fileName = `step_${i + 1}.${ext}`;
                        zip.file(fileName, response.data);
                        count++;
                    } catch (error) {
                        console.error(`Failed to download ${step.filename0}`, error);
                    }
                }
            }

            // recipe.txt 추가
            const recipeData = {
                title: row.title,
                steps: steps.map((step, index) => {
                    let ext = "jpg";
                    if (step.filename0) {
                        const match = step.filename0.match(/\.(png|jpg|jpeg|gif|webp)$/i);
                        if (match) ext = match[1];
                    }
                    return {
                        filename: `step_${index + 1}.${ext}`,
                        title: step.title,
                        instruction: step.instruction,
                    };
                }),
            };
            zip.file("recipe.txt", JSON.stringify(recipeData, null, 2));

            if (count > 0 || steps.length > 0) {
                const content = await zip.generateAsync({ type: "blob" });
                saveAs(content, `${row.title || "recipe"}.zip`);
            } else {
                alert("다운로드할 데이터가 없습니다.");
            }
        } catch (e) {
            console.error(e);
            alert("오류가 발생했습니다.");
        } finally {
            setLoading(false);
        }
    }

    async function handleAllDelete() {
        if (!window.confirm("모든 Step의 이미지를 삭제하시겠습니까?")) return;
        setLoading(true);

        const newSteps = [...row.steps];
        let deletedCount = 0;

        for (let i = 0; i < newSteps.length; i++) {
            const step = newSteps[i];
            if (step.filename0) {
                try {
                    const url = `${process.env.REACT_APP_HOST}/cloudinary/delete_image`;
                    await axios({
                        url,
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            Authorization: `Bearer ${getAccessToken()}`,
                        },
                        data: {
                            url: step.filename0,
                        },
                    });

                    // 불변성 유지를 위해 새로운 객체 생성
                    newSteps[i] = { ...step, filename0: "" };
                    deletedCount++;
                } catch (e) {
                    console.error(`Failed to delete image: ${step.filename0}`, e);
                }
            }
        }

        console.log(newSteps);


        setRow(prev => ({ ...prev, steps: newSteps }));
        setLoading(false);

        setToast({
            isToast: true,
            message: `${deletedCount}개의 이미지가 삭제되었습니다.`,
        });
    }

    return (
        <div className="position-absolute top-0 start-0 bg-light w-100" style={{ zIndex: "999", display: "block" }}>
            <form onSubmit={handleSubmit}>
                <div className="d-flex justify-content-between align-items-center py-3 pe-2 mb-0 bg-body border-bottom">
                    <div className="d-flex flex-row align-items-center">
                        <button
                            type="submit"
                            className={`btn btn-${idx === "add" ? "primary" : "success"} btn-sm ms-2`}
                        >
                            {idx === "add" ? "Add" : "Modify"}
                        </button>

                        <div className="ms-4 d-flex flex-row align-items-center">
                            <input
                                className="form-check-input mt-0"
                                type="checkbox"
                                id="flexCheckDefault"
                                checked={isModifiedUpdate}
                                onChange={(e) => setModifiedUpdate(e.target.checked)}
                            />
                            <label
                                className="form-check-label ms-2 mb-0"
                                htmlFor="flexCheckDefault"
                                style={{ fontSize: "14px" }}
                            >
                                최상위로
                            </label>
                        </div>

                        <div className="ms-4 d-flex flex-row align-items-center">
                            <input
                                className="form-check-input mt-0"
                                type="checkbox"
                                id="illustrationCheck"
                                checked={Boolean(row.is_illustration)}
                                onChange={(e) =>
                                    setRow((prev) => ({
                                        ...prev,
                                        is_illustration: e.target.checked ? 1 : 0,
                                    }))
                                }
                            />
                            <label
                                className="form-check-label ms-2 mb-0"
                                htmlFor="illustrationCheck"
                                style={{ fontSize: "14px" }}
                            >
                                일러스트이미지
                            </label>
                        </div>
                    </div>
                    <button type="button" className="btn-close" onClick={() => modalClose(false)}></button>
                </div>

                <div className="d-flex flex-row py-3">

                    <button type="button" className="btn btn-sm btn-link" onClick={() => setPopup(true)}>
                        텍스트로보기
                    </button>

                    <button type="button" className="btn btn-sm btn-link" onClick={() => setPopup2(true)}>
                        JSON으로 레시피 입력
                    </button>

                </div>

                <input type="hidden" name="idx" readOnly value={idx} />

                <div className="px-2 mt-0 mb-0">
                    <div className="d-flex flex-row">
                        <div style={{ width: "200px" }} className="d-flex flex-column">
                            <div style={{ height: "200px" }} className="shadow">
                                <KyhImageDropUploader
                                    filename={row.filename0 || ""}
                                    onResult={(url) => setRow({ ...row, filename0: url })}
                                />
                            </div>
                            <input
                                type="text"
                                name="filename0"
                                className="form-control form-control-sm mt-1 mb-1"
                                value={row.filename0 || ""}
                                onChange={(e) => setRow({ ...row, filename0: e.target.value })}
                            />
                            <KyhSingleFileUploader onResult={(url) => setRow({ ...row, filename0: url })} />

                            <button
                                type="button"
                                className="w-100 btn btn-sm btn-success text-white py-2 mt-auto"
                                onClick={() => handleAllDownload()}
                            >
                                <i className="bi bi-download me-1"></i>
                                Step 이미지 일괄 다운로드
                            </button>



                            <button
                                type="button"
                                className="w-100 btn btn-sm btn-danger text-white py-2 mt-2"
                                onClick={() => handleAllDelete()}
                            >
                                <i className="bi bi-trash me-1"></i>
                                Step 이미지 일괄 삭제
                            </button>

                            <div className="mt-2">
                                <StepImageMultiFileUploader_V4 row={row} setRow={setRow} />
                            </div>
                        </div>

                        <div className="d-flex flex-column flex-fill ms-1">
                            <div className="form-floating">
                                <input
                                    type="text"
                                    name="title"
                                    className="form-control form-control-sm"
                                    placeholder="제목"
                                    value={row.title || ""}
                                    onChange={(e) => {
                                        setRow({ ...row, title: e.target.value });
                                    }}
                                    required
                                />
                                <label>제목</label>
                            </div>

                            <div className="form-floating">
                                <textarea
                                    name="soge"
                                    className="form-control form-control-sm mt-1"
                                    placeholder="소개글"
                                    style={{ height: "100px" }}
                                    value={row.soge || ""}
                                    onChange={(e) => setRow({ ...row, soge: e.target.value })}
                                    required
                                />
                                <label>소개글</label>
                            </div>

                            <div className="form-floating">
                                <input
                                    type="text"
                                    name="servings"
                                    className="form-control form-control-sm mt-1"
                                    placeholder="인분"
                                    value={row.servings || ""}
                                    onChange={(e) => setRow({ ...row, servings: e.target.value })}
                                />
                                <label>인분</label>
                            </div>

                            <div className="form-floating">
                                <input
                                    type="text"
                                    name="cooking_time"
                                    className="form-control form-control-sm mt-1"
                                    placeholder="조리시간"
                                    value={row.cooking_time || ""}
                                    onChange={(e) => setRow({ ...row, cooking_time: e.target.value })}
                                />
                                <label>조리시간</label>
                            </div>

                            <div className="form-floating">
                                <input
                                    type="text"
                                    name="difficulty"
                                    className="form-control form-control-sm mt-1"
                                    placeholder="난이도"
                                    value={row.difficulty || ""}
                                    onChange={(e) => setRow({ ...row, difficulty: e.target.value })}
                                />
                                <label>난이도</label>
                            </div>
                            <div className="form-floating">
                                <input
                                    list="categorys_option"
                                    type="text"
                                    name="category"
                                    className="form-control form-control-sm mt-1"
                                    placeholder="카테고리"
                                    value={row.category || ""}
                                    onChange={(e) => setRow({ ...row, category: e.target.value })}
                                />
                                <label>카테고리</label>
                            </div>
                            <datalist id="categorys_option">
                                {categorys.map((category, i) => (
                                    <option key={i} value={category} />
                                ))}
                            </datalist>

                            <div className="form-floating">
                                <input
                                    type="text"
                                    name="tags"
                                    className="form-control form-control-sm mt-1"
                                    placeholder="태그"
                                    value={row.tags || ""}
                                    onChange={(e) => setRow({ ...row, tags: e.target.value })}
                                    onBlur={() => {
                                        const tmp = row.tags;
                                        const newTag = replaceAll(tmp, " ", "");
                                        setRow({ ...row, tags: newTag });
                                    }}
                                />
                                <label>태그</label>
                            </div>

                            <div className="form-floating">
                                <input
                                    type="text"
                                    name="writer"
                                    className="form-control form-control-sm mt-1"
                                    placeholder="작성자"
                                    value={row.writer || ""}
                                    onChange={(e) => setRow({ ...row, writer: e.target.value })}
                                />
                                <label>작성자</label>
                            </div>
                            <div className="form-floating">
                                <input
                                    type="text"
                                    name="source"
                                    className="form-control form-control-sm mt-1"
                                    placeholder="출처링크"
                                    value={row.source || ""}
                                    onChange={(e) => setRow({ ...row, source: e.target.value })}
                                />
                                <label>출처링크</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="px-2 mt-0 mb-0">
                    <div className="fw-bold mt-4">재료</div>
                    <RecipeIngredients_V4 gbn="main" row={row} setRow={setRow} />

                    <div className="fw-bold mt-4">양념</div>
                    <RecipeIngredients_V4 gbn="seasoning" row={row} setRow={setRow} />

                    <div className="fw-bold mt-4">기타</div>
                    <RecipeIngredients_V4 gbn="etc" row={row} setRow={setRow} />
                </div>

                <div className="my-5"></div>

                {row.steps.map((step, i) => (
                    <div key={`step_${i}`} className="mb-4">
                        <div className="d-flex flex-row justify-content-between">
                            <button
                                id={`step${i + 1}`}
                                type="button"
                                className="btn btn-sm btn-link text-danger"
                                onClick={() => addRow(i, "up")}
                            >
                                <i className="bi bi-arrow-up"></i>위에 행추가
                            </button>
                            <button type="button" className="btn btn-link text-danger" onClick={() => removeRow(i)}>
                                <i className="bi bi-dash-circle-fill"></i>
                            </button>
                        </div>

                        <RecipeStep_V4 step={step} i={i} row={row} setRow={setRow} />

                        <button type="button" className="btn btn-sm btn-link" onClick={() => addRow(i, "down")}>
                            <i className="bi bi-arrow-down"></i>아래에 행추가
                        </button>
                    </div>
                ))}

                <div className="d-flex justify-content-between align-items-center py-3 pe-2 mb-0 bg-body border-bottom">
                    <div className="d-flex flex-row align-items-center">
                        <button type="submit" className={`btn btn-${idx === "add" ? "primary" : "success"} ms-2`}>
                            {idx === "add" ? "Add" : "Modify"}
                        </button>
                    </div>
                </div>
            </form>

            {popup && <TextViewPopup_V4 row={row} onClose={() => setPopup(false)} />}
            {popup2 && (
                <JsonWritePopup_V4
                    onResult={(json) => {
                        setPopup2(false);
                        if (json !== "") {
                            try {
                                const tmp = JSON.parse(json);
                                setRow(tmp);
                            } catch (e) {
                                console.log(e.message);
                            }
                        }
                    }}
                />
            )}

        </div>
    );
};

export default RecipeDetail_V4;
